module.exports = __webpack_public_path__ + "assets/49910bfc4a4bd3e2eaf3f5941911accd.png";